import { Pen } from 'lucide-react';
import { Link } from 'react-router-dom';
import useJobMakeChangesButton from './useJobMakeChangesButton';

const JobMakeChangesButton: React.FunctionComponent = function ({}) {
  const { show, url } = useJobMakeChangesButton();
  if (!show) return null;
  return (
    <Link to={url}>
      <button
        id="job-make-changes"
        type="button"
        className="flex flex-row gap-x-3 relative transition-all duration-100 ease-in-out w-full whitespace-nowrap bg-orange-200 text-neutral-000 rounded-full disabled:bg-neutral-300 disabled:text-neutral-000 px-4 h-10 text-14-22-em items-center justify-items-center justify-center"
      >
        <Pen size={20} />
        <span className="text-neutral-000 opacity-100">Make changes</span>
      </button>
    </Link>
  );
};

export default JobMakeChangesButton;
